import React from "react";
import "./DescriptionBox.css";
const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviews (122)</div>
      </div>
      <div className="descriptionbox-description">
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Animi esse
          ea deleniti, possimus eos nemo. Eum iure nesciunt, perspiciatis nam,
          cupiditate minus accusamus nihil modi sapiente hic quibusdam sequi
          ducimus! Ipsum, suscipit quod harum expedita blanditiis esse sit amet
          accusantium, ipsam minus quae, voluptate itaque autem iure labore
          doloribus et delectus. Perferendis, voluptatem consequuntur? Ad,
          repellendus? Nulla, tempore ea? Veritatis.
        </p>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cupiditate, unde sint fugit recusandae quis
         necessitatibus quibusdam quas aliquam neque illum distinctio eos modi? Expedita iste dolore autem ut ipsam.</p>
      </div>
    </div>
  );
};

export default DescriptionBox;
